export enum PlaceOrderSide {
  Left = 'Left',
  Right = 'Right',
}

export enum ThemeType {
  Dark = 'Dark',
  Light = 'Light',
}

export enum ThemeClass {
  Dark = 'dark',
  Light = 'light',
}

export enum LeverageType {
  Cross,
  Isolated,
}

export enum MarginActionType {
  Add,
  Remove,
}

export enum ChartType {
  TradingView,
  Depth,
}

export enum ChartViewTabType {
  Chart,
  CoinInfo,
  TradeData,
}

export enum SpotOrderBookViewType {
  Each = 'Each',
  Stack = 'Stack',
}

export enum MarketSortSide {
  Normal = 'Normal',
  Down = 'Down',
  Up = 'Up',
}

export enum PositionMode {
  OneWay = 'OneWay',
  Hedge = 'Hedged',
}

export enum TradeDataMode {
  List,
  Cell,
}
